var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.185 20c.385 0 .701-.138 1.106-.365l10.934-6.331c.79-.455 1.076-.78 1.076-1.304s-.286-.85-1.076-1.304L8.29 4.366C7.886 4.137 7.571 4 7.185 4 6.475 4 6 4.543 6 5.393v13.214C6 19.457 6.474 20 7.185 20z",
    fill: "currentColor"
  })));
}
export default SvgPlayFill;